export class Risk {
    id: number;
    agreementId: number;
    title: string;
    grossChance: number;
    grossImpact: number;
    netChance: number;
    netImpact: number;
    type: number;
    description: string;
    riskControls: Array<RiskControl>;
}

export class RiskControl {
    id: number;
    title: string;
    chanceReduction: string;
    impactReduction: string;
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/risk.model.ts